module.exports = __webpack_public_path__ + "img/edc-qpon.9717ded7.png";